/* unplugin-vue-components disabled */
import LeftControls from './left-controls.vue'
import RightControls from './right-controls.vue'
import InputText from './input-text.vue'

export default {
  components: {LeftControls, RightControls, InputText},
  mixins: [ModelValue(String)],
  props: {
    generating: {type: Boolean, default: false},
    canPush: {type: Boolean, default: false},
    canUpload: {type: Boolean, default: false},
    uploadsEnabled: {type: Boolean, default: true},
    recording: {type: Boolean, default: false},
    placeholder: {type: String, default: 'Ask..'},
    expanded: {type: Boolean, default: false}
  },
  emits: ['push', 'stop', 'upload', 'prompt', 'transcribed', 'show-prompts', 'focusin', 'focusout'],
  data() {
    return {
      input_expanded: this.expanded,
      rows_count: 1,
      focused: false,
    }
  },
  computed:{
    left_padding(){
      let controls_count = 1
      if (this.uploadsEnabled) controls_count++
      if (this.$responsive.desktop) controls_count++
      // Each control adds a 1.6rem icon and 1.6rem of gap or outer padding.
      return `${controls_count * 3.2}rem`
    }
  },
  watch: {
    expanded() {
      const content_width = this.$refs.input.getContentWidth()
      this.input_expanded = this.expanded || content_width > 536 || this.rows_count > 1
    },
    value() {
      if (this.value) return
      this.rows_count = 1
      this.input_expanded = this.expanded
    }
  },
  methods: {
    focus(ev) {
      this.$refs.input.focus(ev)
    },
    blur() {
      this.$refs.input.blur()
    },
    onPrompt(prompt) {
      this.$emit('prompt', prompt)
    },
    onPush(event) {
      this.$emit('push', event)
    },
    onTranscribed(text) {
      this.$emit('transcribed', text)
    },
    onStop() {
      this.$emit('stop')
    },
    handleRow(rows_count) {
      this.rows_count = rows_count
      if (this.input_expanded) return
      this.input_expanded = rows_count > 1
    },
    setCommand(command) {
      this.$refs.input.setCommand(command)
    }
  }
}
